<ion-header>
  <ion-toolbar class="header-toolbar">
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="getDefaultHref()"></ion-back-button>
    </ion-buttons>
    <ion-title>{{'CRUD_ADDRESS_LIB.TITLE' | translate}}</ion-title>

    @if (isFormValid$ | async) {
      <img 
        style="margin-right: 10px;" alt="Point"
        src="assets/icon/whites/point.svg" width="25" slot="end"
        (click)="gotNextPage(true)"
        (keypress)="gotNextPage(true)" />
    }
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <crud-address-info (isValidForm)="gotNextPage($event)" [initAddressInfo]="selectCurrentAddressInfo$ | async"></crud-address-info>
</ion-content>
